'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../../builder');
const TagTree = require('./../../../../bundles/tag/service/tree');
const ListItem = require('./../../../listItem');
const Repository = require('./../../../../bundles/tag/repository/TagRepository');

const ItemSoloTpl = require('./template/item.solo.hbs');

let ElementClass = require('./../../elementClass');

FormBuilder.register('selectTag', function(config) {
  let self = new ElementClass(config);
  let $tree = null;
  let $element;
  let $tagList;
  let $treeWrap;
  let $autocompleteList;
  let $autocompleteWrapper;

  self.addTag = function(item) {
    if ($tagList.find(`[data-uid="${item.id || item.uid}"]`).length > 0) {
      return;
    }

    let $listItem = ListItem.create({
      uid: item.id || item.uid,
      name: item.label,
      buttons: [
        {
          iconClass: 'icon-times',
          onClick: function(e) {
            $listItem.remove();
          },
        },
      ],
    });

    $tagList.append($listItem);
  };

  self.addSoloTag = function(item) {
    let $item = jQuery(ItemSoloTpl(item));

    $element.addClass('d-none');

    $item.find('.remove').on('click', function() {
      $item.remove();
      $element.removeClass('d-none');
    });

    $item.insertAfter($element);
  };

  self.onElementClick = function(e) {
    if (!$tree) {
      TagTree.create({
        onItemClick: function(item) {
          self[config.oneValue ? 'addSoloTag' : 'addTag'](item);

          $tree.addClass('d-none');
        },
        appendTo: $treeWrap,
        showChildren: config.showChildren,
      }).then(($treeTag) => {
        $tree = $treeTag;
      });
    } else {
      $tree.removeClass('d-none');
    }
  };

  self.onKeyUp = function() {
    let val = $element.val();
    let context = config.context || '';

    if (!val) {
      $autocompleteWrapper.addClass('d-none');
      return;
    }

    if ($tree) {
      $tree.addClass('d-none');
    }

    Repository.findBy({term: $element.val()}, context).done((tags) => {
      $autocompleteList.find('li').remove();
      $autocompleteWrapper.removeClass('d-none');

      tags.forEach((tag) => {
        let label = tag.keyword;

        tag.parents.forEach((name, key) => {
          label = `${label} ${key === 0 ? '(' : ''} ${name} ${(key === tag.parents.length - 1) ? ')' : ''}`;
        });

        let $tag = jQuery(`<li data-uid="${tag.uid}">${label}</li>`);
        $tag.on('click', () => {
          self[config.oneValue ? 'addSoloTag' : 'addTag']({
            id: tag.uid,
            label: tag.keyword,
          });

          $autocompleteList.find('li').remove();
          $autocompleteWrapper.addClass('d-none');
        });

        $autocompleteList.append($tag);
      });
    });
  };

  self.render = function($wrap) {
    $element = jQuery('<input class="cloud-tree-input" type="text" />');

    $treeWrap = jQuery('<div class="tree-wrap position-relative" />');
    $tagList = jQuery('<div class="tag-list mt-1" />');
    $autocompleteWrapper = jQuery('<div class="cloud-autocomplete d-none"></div>');
    $autocompleteList = jQuery('<ul class="autocomplete-list"></ul>');

    if (self.disabled) {
      $element.attr('disabled', self.disabled);
      $element.addClass('disabled');
    }

    if (config.readonly) {
      $element.attr('readonly', 'readonly');
    }

    if (undefined !== self.placeholder) {
      $element.attr('placeholder', self.placeholder);
    }

    if (self.elementClass) {
      $element.addClass(self.elementClass);
    }

    if (self.label) {
      let $label = jQuery('<label/>');

      if (self.labelClass) {
        $label.addClass(self.labelClass);
      }

      $label.append(self.label);

      $wrap.append($label);
    }

    $element.on('click', self.onElementClick);
    $element.on('keyup', self.onKeyUp);

    $wrap.append($element);
    $wrap.append($treeWrap);
    $wrap.append($autocompleteWrapper.append($autocompleteList));
    $wrap.append($tagList);

    if (Array.isArray(config.value)) {
      config.value.forEach((item) => {
        self.addTag(item);
      });
    } else {
      if (config.value) {
        Repository.find(config.value).done((tag) => {
          self.addSoloTag({
            id: tag.uid,
            label: tag.keyword,
          });
        });
      }
    }
  };

  self.getData = function() {
    if ($element.siblings('.item').length) {
      return $element.siblings('.item').attr('data-uid');
    }

    let value = [];
    $tagList.children('.cloud-tag').each(function() {
      value.push({
        label: jQuery(this).children('span').text(),
        uid: jQuery(this).attr('data-uid'),
      });
    });

    return value;
  };

  return self;
});
